import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.number.constructor.js";
var BaseModel = /*#__PURE__*/function () {
  function BaseModel(params) {
    _classCallCheck(this, BaseModel);
    this.params = params;
  }
  return _createClass(BaseModel, [{
    key: "get",
    value: function get(param) {
      if (!this.params.hasOwnProperty(param)) {
        throw new Error("Parameter ".concat(param, " does not exist on model ").concat(this.constructor.name));
      }
      return this.params[param];
    }
  }, {
    key: "id",
    value: function id() {
      return Number(this.get('id'));
    }
  }, {
    key: "isExist",
    value: function isExist() {
      return !!this.params;
    }
  }]);
}();
export default BaseModel;